import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import {
  BillingTypeEnum,
  billingTypeEnumMapping
} from '../../../lib/types/enums/cse/billing-type.enum'
import { CseInput } from '../../../lib/types/models/cse/cse'
import { getSelectedEnumOption } from '../../../lib/utils/functions/misc.functions'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'

const CseFacturationAndInsuranceSection = () => {
  const form = useFormContext<CseInput>()
  return (
    <InnerBox title="Facturation & Assurances" className="rounded-xl">
      <FormField
        control={form.control}
        name={'billingType'}
        render={({ field }) => (
          <FormItem className={'flex-1'}>
            <FormControl>
              <ControlledSelectInput<BillingTypeEnum>
                {...field}
                options={Object.values(BillingTypeEnum).map((billing) => ({
                  label: billingTypeEnumMapping[billing],
                  value: billing
                }))}
                dropDownPosition="above"
                label={'Type de facturation'}
                selectedOption={getSelectedEnumOption(field.value, billingTypeEnumMapping)}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <div className="h-4" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Proposer une assurance annulation
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'offerCancellationInsurance'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('offerCancellationInsurance', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'offerCancellationInsurance'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('offerCancellationInsurance', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
      <div className="h-4" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Assurance annulation offerte
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'cancellationInsuranceOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('cancellationInsuranceOffered', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'cancellationInsuranceOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('cancellationInsuranceOffered', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
      <div className="h-4" />
      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Assurance annulation obligatoire
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'cancellationInsuranceMandatory'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('cancellationInsuranceMandatory', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'cancellationInsuranceMandatory'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('cancellationInsuranceMandatory', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
      <div className="h-4" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Assurance rapatriement offerte
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'repatriationInsuranceOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('repatriationInsuranceOffered', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'repatriationInsuranceOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('repatriationInsuranceOffered', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
      <div className="h-4" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Assurance rapatriement obligatoire
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'repatriationInsuranceMandatory'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('repatriationInsuranceMandatory', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'repatriationInsuranceMandatory'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('repatriationInsuranceMandatory', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
      <div className="h-4" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Frais de transport locaux offerts
          </Typography>
          <div className="flex gap-4 items-center">
            <FormField
              control={form.control}
              name={'localTransportCostsOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Oui'}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('localTransportCostsOffered', true, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'localTransportCostsOffered'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Non'}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('localTransportCostsOffered', false, {
                          shouldValidate: true
                        })
                      }
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
    </InnerBox>
  )
}

export default CseFacturationAndInsuranceSection
